__turbopack_context__.v({
  "teaserText": "TeaserText-module-scss-module__j_TBZG__teaserText",
});
